import { TemplateValidatorIssue } from "../../../data-model/templateValidatorModel";
import { RedCrossIcon } from "../../../svg/red-cross-icon";

interface ValidationIssueItemProps {
  issue: TemplateValidatorIssue;
}

const ValidationIssueItem = ({ issue }: ValidationIssueItemProps) => (
  <li className="flex items-start gap-2 text-sm text-gray-800">
    <span className="mt-0.5 shrink-0 text-red-600">
      <RedCrossIcon height="12" width="12" />
    </span>
    <span className="flex-1 text-xs font-normal">
      {[issue.missing_field, issue.reason].filter(Boolean).join(" – ") ||
        issue.line}
      {issue.line && (
        <span className="ml-1 text-gray-500">(Line: {issue.line})</span>
      )}
    </span>
  </li>
);

export default ValidationIssueItem;
